import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store' // Vuex store

// Import main views and components
import QuotesView from '@/views/QuotesView.vue'
import ProfileView from '@/views/ProfileView.vue'
import LoginViewComp from '@/views/LoginVIew.vue'
import ConfirmedReservationsView from '@/views/ConfirmedReservationsView.vue'
import Layout from '@/components/UI/Layout.vue'

// Config
import { RouteConfig } from '@/config'
import Cookies from 'js-cookie'
import { CookieName } from '@/config/cookies'

const routes: Array<RouteRecordRaw> = [
  { path: '/account', redirect: `/account/${RouteConfig.CONFIRMED}` },
  {
    path: `/account/${RouteConfig.LOGIN}`,
    component: LoginViewComp,
  },
  {
    path: '/account',
    component: Layout,
    children: [
      {
        path: RouteConfig.QUOTE,
        component: QuotesView,
        meta: { requiresAuth: true },
      },
      {
        path: RouteConfig.PROFILE,
        component: ProfileView,
        meta: { requiresAuth: true },
      },
      {
        path: RouteConfig.CONFIRMED,
        component: ConfirmedReservationsView,
        meta: { requiresAuth: true },
      },
    ],
  },
  // Catch-all route
  {
    path: '/:catchAll(.*)', // or '/*' for older versions of vue-router
    redirect: `/account/${RouteConfig.CONFIRMED}`,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, behavior: 'smooth' } // Scroll to top smoothly on navigation
  },
})


// Add global navigation guard
router.beforeEach(async (to, from, next) => {
  // if (window.env.VUE_APP_LOCALE === 'fr-FR-CSE' && !Cookies.get(CookieName.COMPANY)) {
  //   // Redirect to the domain root (no path) if company is missing in cookies, for fr-FR-CSE locale
  //   // Remove all cookies
  //   Object.keys(Cookies.get()).forEach((cookieName) => {
  //     Cookies.remove(cookieName);
  //   });
  //   window.location.href = "https://cse.travelski.com/"
  //   return
  // }
  // console.log('locale', window.env.VUE_APP_LOCALE, 'company in cookies', Cookies.get(CookieName.COMPANY))
  if (to.meta.requiresAuth) {
    try {
      // Call the refresh endpoint on the first load
      if (store.state.auth?.calledRefresh) {
        store.dispatch('auth/validateTokens')
      } else {
        await store.dispatch('auth/refresh')
      }
      next() // Continue to the route if successful
    } catch (error) {
      // If there is an error, reset calledRefresh, to call on next login
      store.commit('auth/setCalledRefresh', false)
      console.error(error)

      // Preserve section + opened booking/quote so post-login can restore them
      try {
        const openedRef = typeof to.hash === 'string'
          ? new URLSearchParams(to.hash.replace(/^#/, '')).get('opened[]')
          : null
        if (openedRef) {
          sessionStorage.setItem('pendingPanelOpen', openedRef)
        }
        if (to.path && to.path !== '/account/login') {
          sessionStorage.setItem('pendingAuthRedirect', to.path)
        }
      } catch (storageError) {
        console.error('Error preserving post-login destination:', storageError)
      }

      next('/account/login') // Redirect to login if authentication fails
    }
  } else {
    next() // Continue to the route if no authentication is required
  }
})

export default router
